<template lang="pug">
  .forbidden
    div.d-inline
      b-link.text-dark(@click='logout()') Usuario no autorizado para acceder al sistema. <u>Click para salir</u>
</template>

<script>

import CAS from "../CAS-client";

export default {
  name: "view403",
  methods: {
    logout: function () {
      CAS.logout();
      // this.$emit('logout', event.detail)
    }
  }
}
</script>

<style scoped>

</style>
